import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const expensesReimbursableWidget: DashboardWidgetConfiguration = {
  widgetId: "expenses.reimbursable",
  name: "Reimbursable amount",
  description: "Reimbursable amount for the selected dashboard period.",
  apps: [
    "home",
    "expenses",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "expenses.records",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "reimbursable_amount",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Reimbursable",
    subtext: "in the last 30 days",
    icon: "money",
    color: "warning",
    valueFormat: "currency",
    valueMultiplier: 1,
  },
  dummyData: {
    value: "$12,240",
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
